export class Modules {
    module_additionnel: Module;
    rsv: Module;
    langues: Module;
    devise: Module;
    principallangue: Module;
}

export class Prix {
    value: string;
    unity: string;
}

export class Module {
    name: string;
    value: string;
    imgpath: string;
    description: string;
    prix: Prix;
    selected: boolean;
}


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/models/modules.ts